import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../../data/navigation/navigation.data';
import { THEMES } from '../../../../data/product/product.data';
import { PaidListingKind, Product, paidListingName, resolvePaidListing } from '../../../../model/product/product.model';

/**
 * The Standard EULA of a paid theme listing, addressed like every other product
 * page on the site: /theme/license?platform=<platform>&product=<key>.
 * Which EULA renders follows from the listing (resolvePaidListing); combos
 * without a licence of their own go to not-found, like /theme without a
 * product. The wording is the same text pasted into the Marketplace listing
 * (jetbrains-themes License files).
 */
@Component( {
  selector: 'app-theme-license-page',
  templateUrl: './theme-license-page.component.html',
  styleUrls: [ './theme-license-page.component.scss' ]
} )
export class ThemeLicensePageComponent implements OnInit, OnDestroy {

  URLS = URLS;

  environmentCommon = environmentCommon;

  product: Product | undefined;
  platformName = '';
  kind: PaidListingKind | undefined;

  private routeSub: Subscription | undefined;

  constructor( private route: ActivatedRoute, private router: Router ) {
  }

  ngOnInit(): void {
    this.routeSub = this.route.queryParams.subscribe( params => {
      const productKey = ( params.product || '' ).toLowerCase();
      const product = THEMES
        .map( line => line.products )
        .reduce( ( acc, val ) => acc.concat( val ), [] )
        .find( p => p.key === productKey );
      const resolved = resolvePaidListing( product, params.platform );
      if ( !resolved ) {
        this.router.navigate( [ URLS.notFound ] );
        return;
      }
      this.product = product;
      this.platformName = resolved.platformName;
      this.kind = resolved.kind;
    } );
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

  /** The heading: "All In One Themes License", "Ocean Theme License". */
  get title(): string {
    return this.product ? `${ paidListingName( this.product ) } License` : 'Theme License';
  }
}
